import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoadingComponent } from '../../shared/components/loading/loading.component';

@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [CommonModule, LoadingComponent],
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {
  bookingNumber: string = '';
  isLoading: boolean = true;
  errorMessage: string = '';
  paymentDetails: any = null;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // URL'den order/conversation id al – backend conversationId, oid veya orderId gönderebilir
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const orderId =
        params['conversationId'] ||
        params['oid'] ||
        params['orderId'] ||
        params['OrderId'] ||
        '';
      
      if (orderId) {
        this.fetchBookingResult(orderId);
      } else {
        this.isLoading = false;
        this.errorMessage = 'Ödeme bilgisi bulunamadı. Lütfen rezervasyonlarınızı kontrol edin.';
        
        setTimeout(() => {
          this.router.navigate(['/payment/failed']);
        }, 3000);
      }
    });
  }

  private fetchBookingResult(orderId: string): void {
    const apiUrl = `${environment.apiUrl}/NestPayPayment/booking-result/${encodeURIComponent(orderId)}`;
    
    this.http.get<any>(apiUrl, { withCredentials: true }).subscribe({
      next: (response) => {
        const success = response?.success === true || response?.data?.success === true;
        const bookingNum =
          response?.bookingNumber ||
          response?.data?.bookingNumber ||
          response?.BookingNumber ||
          response?.data?.BookingNumber ||
          response?.reservationCode ||
          response?.data?.reservationCode ||
          '';
        
        if (success && bookingNum) {
          this.isLoading = false;
          this.bookingNumber = bookingNum;
          const data = response?.data || response;
          this.paymentDetails = {
            price: data.price ?? response?.price,
            paidPrice: data.paidPrice ?? response?.paidPrice,
            currency: data.currency ?? response?.currency ?? 'TRY',
            status: data.status ?? response?.status
          };

          this.firePurchaseEvent();
        } else {
          this.isLoading = false;
          this.errorMessage = 'Rezervasyon bilgisi alınamadı. Lütfen müşteri hizmetleri ile iletişime geçin.';
          
          setTimeout(() => {
            this.router.navigate(['/payment/failed']);
          }, 3000);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = 'Rezervasyon bilgisi alınamadı. Lütfen müşteri hizmetleri ile iletişime geçin.';

        setTimeout(() => {
          this.router.navigate(['/payment/failed']);
        }, 3000);
      }
    });
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }

  /**
   * Google Ads + GA4 purchase conversion event.
   * Sadece ödeme başarılı olup bookingNumber alındıktan sonra ÇAĞIRILIR.
   * Mükerrer fire'ı önlemek için sessionStorage işaretler kullanılır.
   */
  private firePurchaseEvent(): void {
    const w = window as any;
    if (typeof w.gtag !== 'function') return;

    // Aynı booking için iki kez gönderme (F5 refresh / geri-gel)
    const dedupeKey = `gtag-purchase-${this.bookingNumber}`;
    try {
      if (sessionStorage.getItem(dedupeKey)) return;
      sessionStorage.setItem(dedupeKey, '1');
    } catch { /* sessionStorage erişimi yoksa sessizce atla */ }

    const value = Number(this.paymentDetails?.paidPrice ?? this.paymentDetails?.price ?? 0);
    const currency = this.paymentDetails?.currency || 'TRY';

    // GA4 purchase event
    w.gtag('event', 'purchase', {
      transaction_id: this.bookingNumber,
      value,
      currency,
      send_to: 'G-HECJVXQ82E',
    });

    // Google Ads conversion (Satın alma işlemi) — conversion label ile aksiyona bağlanır
    w.gtag('event', 'conversion', {
      send_to: 'AW-18104653779/E17zCK_S06waEMPr0sgq',
      transaction_id: this.bookingNumber,
      value,
      currency,
    });
  }
}
